export default __webpack_public_path__ + "static/media/template-hd3.b09e1df8.png";